import { useTranslation } from 'react-i18next'
import { useToggleRefinement } from 'react-instantsearch'
import { useTheme } from 'styled-components'
import { useAlgoliaFilters } from './AlgoliaSearchProvider'
import { NewFilterContainer, StyledFilterCheckbox, StyledLabel } from './styles'

interface NewFilterProps {
  className?: string
  hasNeutralColor?: boolean
}

export const NewFilter = ({ className, hasNeutralColor }: NewFilterProps) => {
  const { t } = useTranslation('collection-filters')
  const { setIsSearchActive } = useAlgoliaFilters()
  const { value, refine } = useToggleRefinement({
    attribute: 'staff_pick_icon_id',
    on: 'new',
  })
  const theme = useTheme()

  // Use the isRefined property from useToggleRefinement to determine checkbox state
  const isChecked = value?.isRefined || false

  const handleToggle = () => {
    setIsSearchActive(true)
    refine(value)
  }

  return (
    <NewFilterContainer className={className}>
      <StyledFilterCheckbox
        id="new-filter"
        checked={isChecked}
        uncheckedBoxColor={
          hasNeutralColor ? theme.colors.text.primary : undefined
        }
        onCheckedChange={handleToggle}
      >
        <StyledLabel htmlFor="new-filter">{t('filterNew')}</StyledLabel>
      </StyledFilterCheckbox>
    </NewFilterContainer>
  )
}
